import { css } from '@emotion/css';

export const modalPaperStyles = css`
  max-height: 54rem;
`;
